import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '@material-ui/core/Input';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MenuIcon from '@material-ui/icons/Menu';
import './Page.css';

@inject('viewStore')
@observer
class Page extends Component {
  contentRef;

  componentWillUnmount() {
    clearTimeout(this.searchTimeout);
  }

  contentMounted = (el) => {
    if (!el) return;

    if (this.props.scrollTop)
      el.scrollTop = this.props.scrollTop;

    if (this.props.contentRef)
      this.props.contentRef(el);
  }

  inputMounted = (el) => {
    // no focus if value is set
    if (!el || this.props.searchValue) return;

    el.focus();
    el.selectionStart = -1;
  }

  render() {
    let contentClasses = 'page-content';

    if (this.props.className) {
      contentClasses += ' ' + this.props.className;
    }

    return (
      <div className="page" >

        <AppBar position="static">
          {
            this.props.searchActive ?
              // If in page that needs search use this [Toolbar].
              <Toolbar classes={{ root: 'bg-white' }}>
                <IconButton onClick={this.props.onSearchClose}>
                  <ArrowBackIcon />
                </IconButton>

                <Input
                  placeholder={this.props.searchPlaceholder || 'Hae'}
                  value={this.props.searchValue}
                  onChange={this.props.onSearchChange}
                  fullWidth
                  disableUnderline
                  inputRef={this.inputMounted}
                />
              </Toolbar> :
              // Else use this [Toolbar].
              <Toolbar>
                {

                  this.props.navigationAction ||
                  <Hidden mdUp implementation="css">
                    <IconButton onClick={this.props.viewStore.openDrawer} color="inherit">
                      <MenuIcon />
                    </IconButton>
                  </Hidden>
                }

                <Typography component={'span'} variant="h6" color="inherit" className="flex">
                  {this.props.title}
                </Typography>

                {!this.props.forbidden && this.props.actions}
              </Toolbar>
          }
        </AppBar>

        <div className="page-wrap"  >
          {
            this.props.forbidden ?
              <div className="padding-md text-center">
                <div>Oikeutesi ei riitä tai yrityksellä ei ole tätä ominaisuutta.</div>
                <div>Ota yhteyttä kirjanpitäjääsi tai Suonentiedon myyntiin.</div>
              </div> :

              this.props.loading ?
                <CircularProgress size={70} /> :

                this.props.error ?
                  <div>
                    <Typography component={'span'} variant="h6">Jokin meni vikaan</Typography>
                    {
                      this.props.onRetry &&
                      <Button
                        className="margin-md-vert"
                        color="primary"
                        onClick={this.props.onRetry}
                      >Yritä uudelleen</Button>
                    }
                  </div> :

                  this.props.empty ?
                    <span>Täällä ei näytä olevan mitään</span> :

                    <div
                      id="searchScrollDiv"
                      className={contentClasses}
                      ref={this.contentMounted}

                    >
                      <div className="page-limiter" >
                        {this.props.children}
                      </div>
                    </div>
          }
        </div>
      </div>
    );
  }
}

export default Page;
